import { Link } from "react-router-dom";

export function LogoMark({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="40" height="40" rx="10" className="fill-primary" />
      {/* main speech bubble */}
      <path
        d="M11 12.5A2.5 2.5 0 0 1 13.5 10h9A2.5 2.5 0 0 1 25 12.5v6A2.5 2.5 0 0 1 22.5 21H17l-4 3.2V21h-.5A1.5 1.5 0 0 1 11 19.5v-7Z"
        className="fill-primary-foreground"
      />
      {/* accent bubble */}
      <path
        d="M22 20.5A2.5 2.5 0 0 1 24.5 18H29a2.5 2.5 0 0 1 2.5 2.5v3A2.5 2.5 0 0 1 29 26h.2v2.6L26 26h-1.5A2.5 2.5 0 0 1 22 23.5v-3Z"
        className="fill-accent"
      />
    </svg>
  );
}

export function Logo({ to = "/", className = "", markClass = "h-8 w-8", textClass = "text-xl", light = false }) {
  return (
    <Link to={to} className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="pitsoio-logo">
      <LogoMark className={markClass} />
      <span className={`font-display font-extrabold tracking-tight ${textClass} ${light ? "text-white" : "text-foreground"}`}>
        Pitso<span className="text-accent">IO</span>
      </span>
    </Link>
  );
}
